import { gql } from '@apollo/client'

export const FICHIER_MUTATION = gql`
  mutation Fichier($data: d4_fichier_insert_input!) {
    fichier: insert_d4_fichier_one(object: $data) {
      id
    }
  }
`

export const FICHIER_QUERY = gql`
  query Fichier($id: bigint!) {
    fichier: d4_fichier_by_pk(id: $id) {
      id
      devisfournisseur_id
      devis_fournisseur {
        id
        demandedevisfournisseur {
          demandedevis_id
          demandedevis {
            id
            objet
            lieuintervention
            reference
            contacts {
              contactssurplace_id
              personne {
                nom
                prenom
                telfixe
                telportable
              }
            }
          }
        }
        fournisseur {
          id
          mail1
          raisonsociale
        }
        montant
        reference
      }
    }
  }
`
